import React from "react";
import { Space } from "antd";
import { FormattedMessage } from "react-intl";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

import SelectEngine from "../../components/SelectEngine";
import SelectOutput from "../../components/SelectOutput";

import { selectors as NODE_SELECTORS } from "../../ducks/node";

const NodeAnalyticsTitle = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const channelId = searchParams.get("c");
  const isTestStarted = useSelector(NODE_SELECTORS.getNodeTestStarted);

  const handleChangeChannel = (selectedEngineId) => {
    searchParams.delete("o");
    searchParams.set("c", selectedEngineId);
    setSearchParams(searchParams);
  };

  return (
    <Space size="large">
      <span>
        <FormattedMessage id="NodeAnalytics.channel" defaultMessage="Channel" />
        {": "}
        <SelectEngine channelId={channelId} handleSelectChange={handleChangeChannel} disabled={isTestStarted} />
      </span>
      <span>
        <FormattedMessage id="SelectOutput.output" defaultMessage="Output" />
        {": "}
        <SelectOutput channelId={channelId} disabled={isTestStarted} />
      </span>
    </Space>
  );
};

export default NodeAnalyticsTitle;
